import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  root: {
    width: "97%",
    height: "60%",
    overflowY: "auto"
  },
  inline: {
    display: "inline"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline"
  },
  boxHistory: {
    display: "flex",
    flexDirection: "column",
    border: "1px solid #CDCDCD",
    borderRadius: "5px",
    marginBottom: "10px",
    padding: "8px",
    backgroundColor: "white"
  },
  headerDate: {
    display: "flex",
    justifyContent: "space-between"
  },
  itemDetail: {
    margin: "0 0 1rem 0"
  },
  content: {
    fontSize: "12px",
    color: "#7E7E7E"
  },
  creator: {
    fontSize: "10px",
    color: "#383838"
  }
}));

export const NewDate = props => {
  const { created_at, className } = props;
  const time = new Date(created_at);
  const date =
    (time.getDate() < 10 ? "0" : "") +
    time.getDate() +
    "." +
    ((time.getMonth() < 10 ? "0" : "") + (time.getMonth() + 1)) +
    "." +
    time.getFullYear() +
    " " +
    ((time.getHours() < 10 ? "0" : "") + time.getHours()) +
    ":" +
    ((time.getMinutes() < 10 ? "0" : "") + time.getMinutes());
  return <Box className={className}>{date}</Box>;
};

const HistoryList = props => {
  const classes = useStyles();
  const { history } = props;

  return (
    <Box>
      <List className={classes.root} dense>
        {history?.map(item => (
          <Box key={item.id} className={classes.boxHistory}>
            <Box className={classes.itemDetail}>
              <Typography className={classes.content}>
                {item.content}
              </Typography>
            </Box>
            <Box className={classes.headerDate}>
              <Box className={classes.creator}>{item.creator}</Box>
              <NewDate
                created_at={item.created_at}
                className={classes.content}
              />
            </Box>
          </Box>
        ))}
      </List>
    </Box>
  );
};

export default HistoryList;
